module.exports = __webpack_public_path__ + "img/img81.565aada6.svg";